angular.module('elidb').filter('menu', function() {
    return function(list,tagSelection) {
    	if(!list || !tagSelection) return list;
    	var trace = angular.trace;

		var results = [];
		
		for(var i = 0, count = list.length; i < count; i++){
			var item = list[i];
			var tags =  item.tags;
			var tagCount = 0;

			for(var j = 0, numTags = tags.length; j < numTags; j++){
				var tag = tags[j];
				var id = tag.id.toString();
				if(tagSelection.indexOf(id) !== -1) tagCount ++;
			}

			item.tagCount = tagCount;

			results.push(item);
		}

		results.sort(sortMenuSelections);

//		trace(results);

		return results;
    };

    function sortMenuSelections(a,b){
    	if(a.tagCount && b.tagCount) {
    		if(a.tagCount > b.tagCount) return -1;
    		else if(a.tagCount < b.tagCount) return 1;
    		else if(a.originIndex > b.originIndex) return 1;
    		return -1;
    	}
    	else if(a.tagCount) return -1;
    	else if(b.tagCount) return 1;
    	else if(a.originIndex > b.originIndex) return 1;
    	return -1;
    }
});